import { apiRequest } from './client';

/**
 * Заявка на подключение предприятия (FR-B2B-01).
 *
 * Ручка публичная: у отправителя ещё нет учётной записи, поэтому запрос
 * уходит без токена. Сервер создаёт учётную запись представителя и заявку
 * на подключение; до подтверждения администратором вход в кабинет не работает.
 */
export interface EnterpriseRegistrationInput {
  /** Юридическое наименование предприятия — обязательное. */
  legalName: string;
  /** ФИО представителя — обязательное. */
  contactName: string;
  /** Контактный телефон — обязательное. */
  contactPhone: string;
  /** E-mail представителя: станет логином кабинета, должен быть уникальным. */
  email: string;
  /** Пароль будущего кабинета: не короче 12 символов. */
  password: string;
  /** Район — необязательно. */
  district?: string;
  /** ИНН — необязательно. */
  inn?: string;
  /** Готовность выделять слоты в неделю — необязательно. */
  slotsPerWeek?: string;
  /** Комментарий — необязательно. */
  message?: string;
}

/** Ответ сервера на успешную регистрацию. */
export interface EnterpriseRegistrationResult {
  ok: boolean;
  /** Идентификатор заявки — по нему администратор ведёт обработку. */
  requestId: string;
  /** Статус заявки: «pending» — ожидает подтверждения. */
  status: string;
}

/**
 * Отправка заявки на регистрацию предприятия.
 * Пустые необязательные поля не передаём — сервер трактует их как «не заполнено».
 */
export async function registerEnterprise(
  input: EnterpriseRegistrationInput,
): Promise<EnterpriseRegistrationResult> {
  const district = input.district?.trim() ?? '';
  const inn = input.inn?.trim() ?? '';
  const slotsPerWeek = input.slotsPerWeek?.trim() ?? '';
  const message = input.message?.trim() ?? '';

  const body = await apiRequest<Partial<EnterpriseRegistrationResult>>('/partner/registration', {
    method: 'POST',
    auth: false,
    body: {
      legalName: input.legalName.trim(),
      contactName: input.contactName.trim(),
      contactPhone: input.contactPhone.trim(),
      email: input.email.trim(),
      password: input.password,
      ...(district ? { district } : {}),
      ...(inn ? { inn } : {}),
      ...(slotsPerWeek ? { slotsPerWeek } : {}),
      ...(message ? { message } : {}),
    },
  });

  return {
    ok: body.ok ?? true,
    requestId: body.requestId ?? '',
    status: body.status ?? 'pending',
  };
}
